import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface FAQItem {
  id: number;
  question: string;
  answer: string;
  isExpanded: boolean;
}

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FaqComponent {
  faqs: FAQItem[] = [
    {
      id: 1,
      question: "Why can't I download the benchmarking datasets?",
      answer:
        'Because the platform is designed to protect the confidentiality of benchmarking datasets while enabling secure evaluation.',
      isExpanded: true,
    },
    {
      id: 2,
      question: 'Will my model be visible to BODH?',
      answer:
        'No. Submitted models are evaluated within a confidential computing environment and are never exposed.',
      isExpanded: false,
    },
    {
      id: 3,
      question: 'Can I contribute a benchmarking dataset?',
      answer:
        'Not currently. If you are interested in contributing a dataset, please contact the team (bodh@tanuh.ai).',
      isExpanded: false,
    },
  ];

  toggleFaq(faqId: number): void {
    const faq = this.faqs.find((f) => f.id === faqId);
    if (!faq) {
      return;
    }

    const shouldExpand = !faq.isExpanded;
    this.faqs.forEach((f) => (f.isExpanded = false));
    faq.isExpanded = shouldExpand;
  }
}
